import React, { useState, useEffect } from "react";
import axios from "axios";

const Pricing = () => {
  const [billing, setBilling] = useState("month");
  const [plans, setPlans] = useState([]);
  const [loadingPlan, setLoadingPlan] = useState(null);

  const [selectedPlan, setSelectedPlan] = useState(null);

 const [customerData, setCustomerData] = useState({
  fullName: "",
  email: "",
  phone: "",
  address: "",
  purpose: "",
});

  //////////////////////////////////////////////////////////
  // LOAD RAZORPAY SCRIPT
  //////////////////////////////////////////////////////////

  // const loadRazorpay = () => {
  //   return new Promise((resolve) => {
  //     if (window.Razorpay) return resolve(true);

  //     const script = document.createElement("script");
  //     script.src = "https://checkout.razorpay.com/v1/checkout.js";
  //     script.onload = () => resolve(true);
  //     script.onerror = () => resolve(false);

  //     document.body.appendChild(script);
  //   });
  // };

  //////////////////////////////////////////////////////////
  // FETCH PRICING
  //////////////////////////////////////////////////////////

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const { data } = await axios.get(
          "https://api.clinicalaiassistance.com/api/productBooking/getpricing"
        );

        if (data.success) {
          setPlans(data.plans);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchPricing();
  }, []);

  //////////////////////////////////////////////////////////
  // HANDLE PAYMENT
  //////////////////////////////////////////////////////////

  // const handlePayment = async (plan, customerData) => {
  //   setLoadingPlan(plan.id);

  //   const loaded = await loadRazorpay();

  //   if (!loaded) {
  //     alert("Razorpay SDK failed to load");
  //     setLoadingPlan(null);
  //     return;
  //   }

  //   try {
  //     const { data } = await axios.post(
  //       "https://api.clinicalaiassistance.com/api/productBooking/create-order",
  //       {
  //         planId: plan.id,
  //         billing,
  //         email: customerData.email,
  //         phone: customerData.phone,
  //         address: customerData.address,
  //         purpose: customerData.purpose,
  //       },
  //       {
  //         headers: {
  //           Auth: localStorage.getItem("token"),
  //         },
  //       }
  //     );

  //     const options = {
  //       key: "rzp_test_b2ELVX63W37hP4",
  //       amount: data.amount * 100,
  //       currency: "INR",
  //       name: "Clinical AI Assistance",
  //       description: plan.name,
  //       order_id: data.orderId,

  //       prefill: {
  //         email: customerData.email,
  //         contact: customerData.phone,
  //       },

  //       notes: {
  //         address: customerData.address,
  //         purpose: customerData.purpose,
  //       },

  //       handler: async function (response) {
  //         try {
  //           const verify = await axios.post(
  //             "https://api.clinicalaiassistance.com/api/productBooking/verify",
  //             {
  //               orderId: response.razorpay_order_id,
  //               paymentId: response.razorpay_payment_id,
  //               signature: response.razorpay_signature,
  //               planId: plan.id,
  //               amount: data.amount,
  //             },
  //             {
  //               headers: {
  //                 Auth: localStorage.getItem("token"),
  //               },
  //             }
  //           );

  //           if (verify.data.success) {
  //             alert("Thank you for showing interest in our product. Our team will reach out to you soon.");

  //             setSelectedPlan(null);

  //             setCustomerData({
  //               email: "",
  //               phone: "",
  //               address: "",
  //               purpose: "",
  //             });
  //           } else {
  //             alert("Payment verification failed");
  //           }
  //         } catch (err) {
  //           console.error(err);
  //           alert("Verification error");
  //         } finally {
  //           setLoadingPlan(null);
  //         }
  //       },

  //       modal: {
  //         ondismiss: function () {
  //           setLoadingPlan(null);
  //         },
  //       },

  //       theme: {
  //         color: "#106EE8",
  //       },
  //     };

  //     const rzp = new window.Razorpay(options);
  //     rzp.open();
  //   } catch (error) {
  //     console.error(error);
  //     alert("Payment failed");
  //     setLoadingPlan(null);
  //   }
  // };

  const handleSubmit = async (plan, customerData) => {
  try {
    setLoadingPlan(plan.id);

    const { data } = await axios.post(
      "https://api.clinicalaiassistance.com/api/productBooking/create-order",
      {
        planId: plan.id,
        billing,
        fullName: customerData.fullName,
        email: customerData.email,
        phone: customerData.phone,
        address: customerData.address,
        purpose: customerData.purpose,
      },
      {
        headers: {
          Auth: localStorage.getItem("token"),
        },
      }
    );

    if (data.success) {
      alert(
        "Thank you for showing interest in our product. Our team will reach out to you soon."
      );

      setSelectedPlan(null);

      setCustomerData({
        fullName: "",
        email: "",
        phone: "",
        address: "",
        purpose: "",
      });
    }
  } catch (error) {
    alert(
      error.response?.data?.message || "Submission failed"
    );
  } finally {
    setLoadingPlan(null);
  }
};
  //////////////////////////////////////////////////////////
  // UI
  //////////////////////////////////////////////////////////

  return (
    <section
      id="pricing"
      className="min-h-screen px-6 py-16 bg-white dark:bg-black text-black dark:text-white"
    >
      <div className="max-w-6xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold">
            Plans and Pricing
          </h2>

          <p className="text-gray-500 dark:text-gray-400 mt-4 max-w-xl mx-auto">
            Every plan includes complete chart review capabilities. Start free
            and scale from solo practitioners to enterprise health systems.
          </p>
        </div>

        {/* BILLING TOGGLE */}
        <div className="flex justify-center mb-12">
          <div className="flex bg-gray-200 dark:bg-gray-800 rounded-full p-1">
            {["month", "year"].map((type) => (
              <button
                key={type}
                onClick={() => setBilling(type)}
                className={`px-5 py-2 rounded-full text-sm font-medium ${
                  billing === type
                    ? "bg-white dark:bg-black shadow"
                    : ""
                }`}
              >
                {type === "month" ? "Month" : "Year"}
              </button>
            ))}

            <span className="px-4 py-2 text-sm text-[#106EE8]">
              Discount
            </span>
          </div>
        </div>

        {/* PRICING CARDS */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {plans.map((plan, index) => {
            const price =
              plan.price ||
              (billing === "year"
                ? plan.yearlyPrice
                : plan.monthlyPrice);

            return (
              <div
                key={index}
                className={`border rounded-xl p-6 border-gray-200 dark:border-gray-800 bg-white dark:bg-[#0f0f0f] ${
                  plan.popular ? "relative shadow-lg" : ""
                }`}
              >
                {plan.popular && (
                  <span className="absolute top-5 right-5 bg-[#106EE8] text-white text-xs px-3 py-1 rounded-full">
                    Popular
                  </span>
                )}

                <h3 className="font-semibold text-lg">
                  {plan.name}
                </h3>

                <p className="text-4xl font-bold mt-4">
                  {typeof price === "number"
                    ? `€${price}`
                    : price}

                  {typeof price === "number" && (
                    <span className="text-base font-normal text-gray-500">
                      {plan.name === "Team"
                        ? "/User/Month"
                        : "/Month"}
                    </span>
                  )}
                </p>

                <p className="text-gray-500 dark:text-gray-400 mt-3">
                  {plan.description}
                </p>

                <button
                  onClick={() => {
                    if (plan.name === "Enterprise") {
                      const section =
                        document.getElementById("subscription");

                      if (section) {
                        section.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }

                      return;
                    }

                    setSelectedPlan(plan);

                    setCustomerData({
                      email: "",
                      phone: "",
                      address: "",
                      purpose: "",
                    });
                  }}
                  className={`w-full mt-6 py-3 rounded-lg ${
                    plan.name === "Team"
                      ? "bg-[#106EE8] hover:bg-[#0d5bbd] text-white"
                      : plan.name === "Enterprise"
                      ? "bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
                      : "border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800"
                  }`}
                >
                 
                   Subscribe now
                </button>

                <ul className="mt-6 space-y-3 text-sm">
                  {plan.features.map((f, i) => (
                    <li key={i}>✔ {f}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* SUBSCRIPTION FORM */}
        {/* SUBSCRIPTION MODAL */}
{selectedPlan && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
    <div className="w-full max-w-2xl rounded-2xl bg-white dark:bg-[#0f0f0f] shadow-2xl border border-gray-200 dark:border-gray-700">
      
      {/* Header */}
      <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
        <div>
          <h3 className="text-2xl font-bold">
            Complete Subscription
          </h3>

          <p className="text-sm text-gray-500 mt-1">
            Selected Plan:
            <span className="font-semibold ml-2 text-[#106EE8]">
              {selectedPlan.name}
            </span>
          </p>
        </div>

        <button
          onClick={() => setSelectedPlan(null)}
          className="text-2xl leading-none hover:text-red-500"
        >
          ×
        </button>
      </div>

      {/* Body */}
      <div className="p-6 space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
  <label className="block text-sm mb-2">
    Full Name
  </label>

  <input
    type="text"
    placeholder="Enter your full name"
    value={customerData.fullName}
    onChange={(e) =>
      setCustomerData({
        ...customerData,
        fullName: e.target.value,
      })
    }
    className="w-full border border-gray-300 dark:border-gray-700 rounded-lg p-3 bg-transparent"
  />
</div>
         <div>
  <label className="block text-sm mb-2">
    Email
  </label>

  <input
    type="email"
    placeholder="Enter your email"
    value={customerData.email}
    onChange={(e) =>
      setCustomerData({
        ...customerData,
        email: e.target.value,
      })
    }
    className="w-full border border-gray-300 dark:border-gray-700 rounded-lg p-3 bg-transparent"
  />
</div>

          <div>
            <label className="block text-sm mb-2">
              Phone
            </label>

            <input
              type="tel"
              placeholder="Enter phone number"
              value={customerData.phone}
              onChange={(e) =>
                setCustomerData({
                  ...customerData,
                  phone: e.target.value,
                })
              }
              className="w-full border border-gray-300 dark:border-gray-700 rounded-lg p-3 bg-transparent"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm mb-2">
            Address
          </label>

          <textarea
            rows={3}
            placeholder="Enter address"
            value={customerData.address}
            onChange={(e) =>
              setCustomerData({
                ...customerData,
                address: e.target.value,
              })
            }
            className="w-full border border-gray-300 dark:border-gray-700 rounded-lg p-3 bg-transparent"
          />
        </div>

        <div>
          <label className="block text-sm mb-2">
            Purpose
          </label>

          <textarea
            rows={3}
            placeholder="Why are you subscribing?"
            value={customerData.purpose}
            onChange={(e) =>
              setCustomerData({
                ...customerData,
                purpose: e.target.value,
              })
            }
            className="w-full border border-gray-300 dark:border-gray-700 rounded-lg p-3 bg-transparent"
          />
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700">
        <button
          onClick={() => setSelectedPlan(null)}
          className="px-6 py-3 rounded-lg border border-gray-300 dark:border-gray-700"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            if (
  !customerData.fullName ||
  !customerData.email ||
  !customerData.phone ||
  !customerData.address ||
  !customerData.purpose
) {
  return alert("Please fill all fields");
}

            handleSubmit(selectedPlan, customerData);
          }}
          disabled={loadingPlan === selectedPlan.id}
          className="px-6 py-3 rounded-lg bg-[#106EE8] text-white hover:bg-[#0d5bbd]"
        >
          {loadingPlan === selectedPlan.id
            ? "Processing..."
            : "Submit"}
        </button>
      </div>
    </div>
  </div>
)}
      </div>
    </section>
  );
};

export default Pricing;